
// 
import DateHelpers from '../helpers/DateHelpers'
import {differenceInCalendarDays, format} from 'date-fns'
import { isDate } from 'date-fns/esm';

export default class {

    static isMobileNumber(str) {
        const phoneNumber = str.replace(/\D/g, '')
        if(phoneNumber.indexOf('04') != 0)
            return false
        
        return phoneNumber.length == 10
    }
    
    static capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
    }

    static removeSpaces(str) {
        return str.replace(/\s/g, '_')
    }
    static restoreSpaces(str) {
        return str.replace(/\_/g, ' ')
    }

    static sentenceJoin(array) {
        if(!array || array.length < 1)
            return ''
        
        let returnValue = ''
        for (var n=0; n < array.length; n++) {
            let currentItem = array[n]
            if(currentItem) {
                returnValue += currentItem
                if(n == array.length - 2)
                    returnValue += ' and '
                else if(n < array.length - 2)
                    returnValue += ', '
            }
        }

        return returnValue
    }

    static acronym(string) {
        let arr = string.split(' ')
        let initialArray = arr.map(i => i.substr(0,1))
        return initialArray.join('')
    }

    static toKebabCase(str) {
        return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase().replace(' ', '-')
    }

    static toSnakeCase(str) {
        // converts 'This isTest' to 'this_is_test'
        return str
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
        .map(x => x.toLowerCase())
        .join('_')
    }

    static snakeToNormal(str) {
        return this.toTitleCase( str.replace('_', ' ') )
    }

    static toTitleCase(str) {
        return str.replace(
            /\w\S*/g,
            function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
            }
        )
    }

    static toCamelCase (str) {
        if(!str)
            return ''
        str = str.replace(/\./g, ' ')
        return str.toLowerCase().replace(/(?:^\w|[A-Z]|\b\w)/g, (ltr, idx) => idx === 0 ? ltr.toLowerCase() : ltr.toUpperCase()).replace(/\s+/g, '');
    }

    static camelToNormal(str) {
        //from: https://stackoverflow.com/questions/4149276/javascript-camelcase-to-regular-form
        // this didnt work on 'marketing#4' so rewrote manually....return str.replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); })
        let result = ''
        let prevLower = false
        for (let i = 0; i < str.length; i++) {
            const currentChar = (str.charAt(i))
            const currentLower = this.isLowerCase(currentChar)
            if(prevLower && !currentLower)
                result += ' '
            result += currentChar
            prevLower = currentLower
        }
        return this.capitalizeFirstLetter(result)
    }

    static isAlphabetic(str) {
        return (str && /^[a-zA-Z]+$/.test(str))
    }

    static isUpperCase(str) {
        return this.isAlphabetic(str) && str == str.toUpperCase()
    }

    static isLowerCase(str) {
        return this.isAlphabetic(str) && str == str.toLowerCase()
    }

    static dueString(date) {
        if(!date)
            return 'Not Scheduled'

        return 'Due ' + DateHelpers.fromNow(date).toLowerCase()
    }

    static sortKey () {
        return parseInt(
            format(new Date(), 'yyMMddHHmmssSS')
        )
    }

    static randomString(length) {
        const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
        var result = ''
        for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)]
        return result
    }

    static firstWord(str) {
        if(!str)
            return ''
        return str.split(' ')[0].trim()
    }

    static dateStamp () {
        return format(new Date(), 'yy-MM-dd')
    }

    static replaceAt (str, index, replacement) {
        return str.substr(0, index) + replacement+ str.substr(index + replacement.length);
    }

    static formatPercent(num) {
        if(!num)
            return 'Nil'
        
        return (num * 100).toString() + '%'
    }

    static formatPhone (phoneNumber) {
        if(!phoneNumber)
            return ''
        let s = phoneNumber.replace(/\D/g,'')
        let arr = [...s]
        if(arr.length == 10 && arr[0] == '0') {
            if(arr[1] == '4') {
                phoneNumber = '04' + arr[2] + arr[3] + ' ' + arr[4] + arr[5] + arr[6] + ' '  + arr[7] + arr[8] + arr[9]
                console.log(phoneNumber)
            } else
                phoneNumber = '0' + arr[1] + ' ' + arr[2] + arr[3] + arr[4] + arr[5] + ' ' + arr[6] + arr[7] + arr[8] + arr[9]
        }
        return phoneNumber       
    }

    static formatMailTo(email) {
        if(!this.isEmail(email))
            return ''
        return `<a style="color:#1976d2!important" href="mailto:${email}">${email}</a>`
    }

    static formatNumber(num) {
        if(!num)
            return ''
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

    static blockReturns(value) {
        return value.replace(/(?:\r\n|\r|\n)/g, '<br />')
    }



    static formatFloat(value) {
        if(!value)
            return ''
        
        let newVal =  value.toString().replace(/[^0-9\.]+/g,'')
        return parseFloat(newVal)
    }
    
    static formatInteger(value) {
        if(!value)
            return ''
        
        // let newVal =  value.toString().replace(/\D/g,'')
        let newVal =  value.toString().replace(/[^0-9.]/g,'')
        return parseInt(newVal)
    }

    static formatCurrency(num) {
        if(!num || isNaN(num))
            return ''

        //num = parseInt(num)
        num = this.formatInteger(num)

        var p = num.toFixed(2).split(".")
        return "$" + p[0].split("").reverse().reduce(function(acc, num, i, orig) {
            return  num=="-" ? acc : num + (i && !(i % 3) ? "," : "") + acc;
        }, "") //+ "." + p[1];
    }

    static formatCurrencyWithCents(num) {
        if(!num || isNaN(num))
            return ''

        num = parseFloat(num)

        var p = num.toFixed(2).split(".")
        return "$" + p[0].split("").reverse().reduce(function(acc, num, i, orig) {
            return  num=="-" ? acc : num + (i && !(i % 3) ? "," : "") + acc;
        }, "") + "." + p[1]
    }

    static rootPath() {
        let path = window.location.protocol + "//" + window.location.host + "/"
        // if(path.indexOf('localhost') > -1)
        //     path = 'https://taco.insightprocessing.com.au/'
        return path
    }

    static linkToTaco(path, text) {
        return '<a href="' + this.rootPath() + path + '" target="_blank" style="text-decoration:none;margin:0 auto;">'
         + '<div style="padding:7px 12px;background-color:#1976d2;color:white;border-radius:4px;cursor:pointer;user-select:none;display:inline-block;margin: 0 auto">'
         + text 
         + '</div>'
         + '</a>'
    }

    static imagePath() {            
        return this.rootPath() + 'static/images/'
    }

    static truncate(str, len) {
        return (str.length > len) ? str.substr(0, len-1) : str
    }
    
    static truncateDots(str, len) {
        if(!str || str.length < len)
            return str
        return this.truncate(str, len) + '...'
    }

    static mentions(str) {
        let rx = /(?:^|\s)(@[a-z0-9]\w*)/gi
        let results = str.match(rx) || []
        return results.map(word => word.trim())
    }
 
    static hashtags(str) {
        let rx = /(?:^|\s)(#[a-z0-9]\w*)/gi
        let results = str.match(rx) || []
        return results.map(word => word.trim())
    }

    static isEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase())
    }

    static removeHtml(htmlString, omitNewLines = false) {
        if(!omitNewLines)
            htmlString = htmlString.replace(/<br\s*[\/]?>/gi, "\n")
        let div = document.createElement("div")
        div.innerHTML = htmlString
        return div.textContent || div.innerText || ""
    }


}


// WEBPACK FOOTER //
// ./src/helpers/StringHelpers.js